/**
 * RESOURECES PAGE JS
 * REQUIRES: measurements (array of images and title)
 * LOCATION: RESOURECES PAGE (page.resources.liquid)
 * /assets/resources.js
 * Reviewed: -
 */
$(function() {
	$('.youtube_popup').magnificPopup({
        type: 'iframe',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
    $('.popup').magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1] // Will preload 0 - before current, and 1 after the current image
        },
        image: {
            verticalFit: true
        }
    });
});